@if (isVisible) {
  <form-control [question]="componentData" [flow]="flowComponent">
    <textarea lunaInput [id]="controlId" [name]="controlName" [(ngModel)]="contextValue"
      [formControl]="formGroup.controls[componentData.key]">
    </textarea>
  </form-control>
}
